import { themes } from '../index.js';
import darkClassic from './dark-classic.css.js';

themes["dark-classic"] = darkClassic;
//# sourceMappingURL=index.js.map
